import { render, staticRenderFns } from "./gutter.vue?vue&type=template&id=2a45c884"
import script from "./gutter.vue?vue&type=script&lang=js"
export * from "./gutter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports